<div
  *ngIf="control"
  #container
>
  <label  class="form-label "
          *ngIf="label"
          [for]="name"
  >{{ label }}
  </label>

  <div >
    <div class="input-group"  >

      <input [value]="readonlyItem ? readonlyItem.text : null"
             [id]="name"
             class="form-control"
             type="text"
             [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
             [class.is-valid]="control.touched && control.valid"
             readonly
             disabled
      >


      <div class="invalid-feedback" *ngIf="!!control.getError('serverError')">{{ control.getError('serverError') }}</div>


      <ng-container *ngFor="let err of control.errors | keyvalue">
        <ng-container *ngIf="(control.touched && control.invalid)">
          <div *ngIf="errorMessages && errorMessages[err.key] " class="invalid-feedback">
            {{ errorMessages[err.key] }}
          </div>
          <div *ngIf="(!errorMessages || !errorMessages[err.key] ) && err.key !== 'serverError'" class="invalid-feedback">
            {{ 'forms.errors.' + err.key | translate }}
          </div>
        </ng-container>

      </ng-container>


    </div>
  </div>
</div>
